import { PageTitleComponent } from '@app/shared/components/page-title/page-title.component';
import { inject, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModulesService } from '@shared/services/modules.service';
import { Router } from '@angular/router';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
/**
 * Tarjetas del menú de reportes.
 *
 * Mismo caso que `audit-menu`: antes se filtraban del árbol de navegación
 * que venía del `epione-core-api` (shell de Module Federation). Las rutas
 * hijas de `reports` ya son estáticas en `app.routes.ts` y los textos
 * siempre estuvieron aquí, así que las tarjetas se declaran directo.
 */
const REPORT_CARDS: card[] = [
  {
    title: 'Consolidación de remisiones',
    description: 'Remisiones por pieza con OC, folio de CX y factura (pendiente / con novedad / facturada).',
    icon: 'receipt_long',
    route: 'remissions'
  },
  {
    title: 'Consolidación de folios',
    description: 'Todos los folios del periodo, un renglón por pieza (incluye fuera de inventario).',
    icon: 'assignment',
    route: 'folios'
  },
  {
    title: 'Incidencias por estado',
    description: 'Incidencias del periodo: justificadas o no, con o sin MPXR, clasificación (calidad), código y lote.',
    icon: 'report_problem',
    route: 'incidentsByStatus'
  },
  {
    title: 'Incidencias por lote y producto',
    description: 'Cuántas incidencias tiene cada lote y código: justificadas, con MPXR y de calidad.',
    icon: 'inventory',
    route: 'incidentsByLot'
  },
  {
    title: 'Solicitado vs entregado',
    description: 'Consigna de SAP contra lo que entró por DLV, por hospital y código.',
    icon: 'compare_arrows',
    route: 'deliveriesVsSap'
  },
];

export interface card {
  title: String,
  description: String,
  icon: String,
  route: String
}

@Component({
  standalone: true,
  imports: [PageTitleComponent, 
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-reports-menu',
  templateUrl: './reports-menu.component.html',
  styleUrls: ['./reports-menu.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ReportsMenuComponent implements OnInit {
  private modulesSvcTitle = inject(ModulesService);
  /** Título del módulo = etiqueta visible del catálogo de Módulos. */
  title = this.modulesSvcTitle.moduleTitle('/reports', 'Reportes');


  componentRoutes = [];
  menuCards: card[];
 

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.menuCards = REPORT_CARDS;
  }

  /**
   * @description Navigation to the children
   */
  navigationTo(route){
    //console.log(route)
    this.router.navigate(['/reports/' + route]);
  }
}